define("SDB.Modal.Content.View", ["SCView", "sdb_modal_content.tpl"], function (
  SCViewModule,
  sdb_modal_content_tpl
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  var SDBModalContentView = function SDBModalContentView(options) {
    SCView.call(this);

    this.options = options || {};
    this.template = sdb_modal_content_tpl;

    this.attributes = {
      id: "SDBModalContentViewId",
      class: "sdb-modal-content-view",
    };

    this.page_header = this.options.pageHeader || this.getTitle();
    this.modalClass = this.attributes.class;

    this.childViews = {
      "Content.View": function ContentView() {
        var contentView = this.options.contentView;
        if (!contentView) return;

        return new contentView({
          container: this.options.container,
          parentView: this,
          isMake: this.options.isMake,
          notRedirect: this.options.notRedirect,
          showContinue: this.options.showContinue,
        });
      },
    };

    this.getContext = function getContext() {
      return {
        hasContentView: !_.isUndefined(this.options.contentView),
      };
    };
  };

  SDBModalContentView.prototype = Object.create(SCView.prototype);
  SDBModalContentView.prototype.constructor = SDBModalContentView;

  return SDBModalContentView;
});
